export const RECENTLY_VIEWED_PRODUCTS_KEY = 'recently_viewed_products'
